// Tipos, estados y catálogos de tickets, alineados con ITIL 4.
//  · INC  Incidente: algo que funcionaba dejó de funcionar o se degradó. Objetivo: restablecer
//         el servicio cuanto antes (práctica de Gestión de incidentes). Sin estimado.
//  · SOL  Solicitud de servicio: petición rutinaria, conocida y de bajo riesgo — consultas,
//         accesos, ejecutar un proceso o reporte, ajustar un parámetro conocido. Preaprobada,
//         sin estimado (práctica de Gestión de solicitudes de servicio).
//  · REQ  Requerimiento: crear o modificar funcionalidad (cambio normal). Siempre lleva
//         estimado y aprobación del cliente antes de trabajarse (Habilitación de cambios).
//  · PRY  Proyecto: un requerimiento de más de 180 h; se gestiona en Veta.
// La facturación (bolsa vs. adicional) depende de las horas, no del tipo: ver sizing.ts.
export const TICKET_TYPES = ['INC', 'SOL', 'REQ', 'PRY'];
/** Tipos que se crean directamente; PRY nace de convertir un REQ por su estimado. */
export const CREATABLE_TYPES = ['INC', 'SOL', 'REQ'];
export const TICKET_TYPE_LABEL = {
    INC: 'Incidente',
    SOL: 'Solicitud de servicio',
    REQ: 'Requerimiento',
    PRY: 'Proyecto'
};
/** Ayuda para clasificar al registrar un ticket. */
export const TICKET_TYPE_HELP = {
    INC: 'Algo que funcionaba dejó de funcionar o funciona mal.',
    SOL: 'Algo rutinario y conocido: consultas, accesos, correr un proceso o reporte. Sin estimado.',
    REQ: 'Crear o modificar funcionalidad. Requiere estimado y aprobación del cliente.',
    PRY: 'Requerimiento de más de 180 h; se gestiona como proyecto en Veta.'
};
/** ¿El tipo pasa por estimación y aprobación del cliente? */
export const needsEstimate = (type) => type === 'REQ';
export const STATUSES = [
    'new', 'assigned', 'estimating', 'pending_approval', 'approved', 'in_progress',
    'on_hold', 'resolved', 'closed', 'cancelled', 'rejected', 'converted'
];
export const STATUS_LABEL = {
    new: 'Nuevo',
    assigned: 'Asignado',
    estimating: 'En estimación',
    pending_approval: 'Pendiente de aprobación',
    approved: 'Aprobado',
    in_progress: 'En progreso',
    on_hold: 'En espera',
    resolved: 'Resuelto',
    closed: 'Cerrado',
    cancelled: 'Cancelado',
    rejected: 'Rechazado',
    converted: 'Convertido a proyecto'
};
/** Estados en los que el ticket ya no está abierto. */
export const FINAL_STATUSES = ['closed', 'cancelled', 'rejected', 'converted'];
export const isOpenStatus = (s) => !FINAL_STATUSES.includes(s);
export const HOLD_REASONS = ['customer', 'third_party', 'scheduled_change'];
export const HOLD_REASON_LABEL = {
    customer: 'Esperando al cliente',
    third_party: 'Esperando a tercero / SAP',
    scheduled_change: 'Cambio programado'
};
export const RESOLUTION_CODES = [
    'permanent_fix', 'workaround', 'request_fulfilled', 'user_error', 'not_reproducible', 'duplicate', 'change_implemented'
];
export const RESOLUTION_LABEL = {
    permanent_fix: 'Solución definitiva',
    workaround: 'Solución alternativa (workaround)',
    request_fulfilled: 'Solicitud atendida',
    user_error: 'Error del usuario / capacitación',
    not_reproducible: 'No reproducible',
    duplicate: 'Duplicado',
    change_implemented: 'Cambio implementado'
};
export const CHANNELS = ['email', 'phone', 'portal', 'internal'];
export const CHANNEL_LABEL = {
    email: 'Correo',
    phone: 'Teléfono',
    portal: 'Portal',
    internal: 'Interno'
};
//# sourceMappingURL=tickets.js.map